import React from 'react';
import * as Panel2 from './panel';
import BokehViewer from './BokehViewer';
import * as Op from './cg/ops';
import {useAssetContentFromArtifact} from './useAssetFromArtifact';

const inputType = 'bokeh-file' as const;

const PanelBokeh: React.FC<Panel2.PanelProps<typeof inputType>> = props => {
  const inputNode = props.input.path;
  const assetResult = useAssetContentFromArtifact(
    inputNode,
    Op.opBokehArtifact
  );
  if (assetResult.loading) {
    return <div></div>;
  } else {
    return (
      <BokehViewer
        bokehJson={
          assetResult.contents ? JSON.parse(assetResult.contents) : null
        }
      />
    );
  }
};

export const Spec: Panel2.PanelSpec = {
  id: 'bokeh',
  Component: PanelBokeh,
  inputType,
};
